import { render, staticRenderFns } from "./HousingTab.vue?vue&type=template&id=ef37f824"
import script from "./HousingTab.vue?vue&type=script&lang=js"
export * from "./HousingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports